import ModalPortal from '../../common/components/ModalPortal.js'
import EditCartIntegrationBridgeModal from '../Settings/Modals/EditCartIntegrationBridgeModal.js'
import EditCartLocationWarehousesModal from '../Settings/Modals/EditCartLocationWarehousesModal.js'
import EditCartModal from '../Settings/Modals/EditCartModal.js'
import EditAddressModal from './EditAddressModal/index.js'
import PasteAddressModal from '../../common/components/Modal/PasteAddressModal.js'
import EditTagModal from '../../common/components/Modal/EditTagModal.js'
import DeleteTagsModal from '../../common/components/Modal/DeleteTagsModal.js'
import ConfirmAttemptToAllocateModal from '../../common/components/Modal/ConfirmAttemptToAllocateModal.js'
import ConfirmDeallocateModal from '../../common/components/Modal/ConfirmDeallocateModal.js'
import ExportInsuranceHistoryModal from '../../common/components/Modal/ExportInsuranceHistoryModal.js'
import ConfirmDropshipProductModal from '../../common/components/Modal/ConfirmDropshipProductModal.js'
import EndiciaCreditCardModal from '../../common/components/Modal/EndiciaCreditCardModal/index.js'
import ListOnAmazonModal from '../../common/components/Modal/ListOnAmazonModal.js'
import CreateChargeModal from '../../common/components/Modal/CreateChargeModal.js'
import ConfirmArchiveProductModal from '../../common/components/Modal/ConfirmArchiveProductModal.js'
import ConfirmExcessiveFulfillmentLatencyModal from '../../common/components/Modal/ConfirmExcessiveFulfillmentLatencyModal.js'
import PrintPickPackModal from '../../common/components/Modal/PrintPickPackModal.js'
import CreateProductModal from '../ProductListPage/Modals/CreateProductModal.js'
import EditInstructionsModal from '../../common/components/Modal/EditInstructionsModal.js'
import CartSyncModal from './CartSyncModal/index.js'
import ConfirmMessageModal from '../../common/components/Modal/ConfirmMessageModal.js'
import CreateRuleModal from './CreateRuleModal.js'
import CreditCardModal from './CreditCardModal.js'
import FeatureLockedModal from './FeatureLockedModal.js'
import FilterSettingsModal from './FilterSettingsModal.js'
import ReactivationLockedModal from './ReactivationLockedModal.js'
import UnrecoverableErrorModal from './UnrecoverableErrorModal.js'
import UpgradeModal from './UpgradeModal.js'
import WarehouseModal from './WarehouseModal.js'
import WarehouseCartLocationNoticeModal from '../Settings/Modals/WarehouseCartLocationNoticeModal.js'
import CancellationModal from './CancellationModal.js'
import EditReportModal from '../ReportsPage/Modals/EditReportModal.js'
import AccountCreditCardModal from './AccountCreditCardModal.js'
import InventoryMgmtModuleModal from './InventoryMgmtModuleModal.js'
import OrderListFilterModal from '../OrderListPage/Modals/OrderListFilterModal/index.js'
import AppMessageModal from './AppMessageModal.js'
import AutoFillPostageModal from './AutoFillPostageModal.js'
import OldUpgradeModal from './OldUpgradeModal.js'
import ScheduleExpertModal from './ScheduleExpertModal.js'
import WelcomeTabModal from './WelcomeTabModal.js'
import PresetSortModal from '../Settings/Presets/PresetSortModal.js'
import ProductListFilterModal from '../ProductListPage/Modals/ProductListFilterModal/index.js'
import ProcessLabelModal from '../OrderListPage/Modals/ProcessLabelModal.js'
import PaymentAccountsModal from './PaymentAccountsModal.js'
import PaymentTransferModal from './PaymentTransferModal.js'
import ShipperSortModal from '../Settings/Shippers/ShipperSortModal.js'
import VideoModal from './VideoModal.js'
import POListFilterModal from '../PurchaseOrderListPage/Modals/POListFilterModal/index.js'
import AddEditContactModal from '../Settings/Contacts/AddEditContactModal.js'
import EditTopNavModal from '../Header/EditTopNavModal.js'
import LabelConfigModals from '../LabelConfig/Modals/index.js'
import CreateInventoryTransferModal from '../TransferListPage/Modals/CreateInventoryTransferModal/index.js'

export default function Modals() {
  return (
    <>
      <ModalPortal>
        <ConfirmAttemptToAllocateModal />
        <ConfirmDeallocateModal />
        <ExportInsuranceHistoryModal />
        <ConfirmDropshipProductModal />
        <EndiciaCreditCardModal />
        <ListOnAmazonModal />
        <ConfirmArchiveProductModal />
        <ConfirmExcessiveFulfillmentLatencyModal />
        <EditInstructionsModal />
      </ModalPortal>
      <AccountCreditCardModal />
      <AddEditContactModal />
      <AppMessageModal />
      <AutoFillPostageModal />
      <CancellationModal />
      <CartSyncModal />
      <ConfirmMessageModal />
      <CreateChargeModal />
      <CreateInventoryTransferModal />
      <CreateProductModal />
      <CreateRuleModal />
      <CreditCardModal />
      <DeleteTagsModal />
      <EditAddressModal />
      <EditCartIntegrationBridgeModal />
      <EditCartLocationWarehousesModal />
      <EditCartModal />
      <EditReportModal />
      <EditTagModal />
      <EditTopNavModal />
      <FeatureLockedModal />
      <FilterSettingsModal />
      <InventoryMgmtModuleModal />
      <LabelConfigModals />
      <OldUpgradeModal />
      <OrderListFilterModal />
      <PasteAddressModal />
      <PaymentAccountsModal />
      <PaymentTransferModal />
      <POListFilterModal />
      <PresetSortModal />
      <PrintPickPackModal />
      <ProcessLabelModal />
      <ProductListFilterModal />
      <ReactivationLockedModal />
      <ScheduleExpertModal />
      <ShipperSortModal />
      <UnrecoverableErrorModal />
      <UpgradeModal />
      <WarehouseModal />
      <WarehouseCartLocationNoticeModal />
      <WelcomeTabModal />
      <VideoModal />
    </>
  )
}
